import React from 'react';

const ProgressChartLabel = ({ color, title }) => {
  return (
    <div className="progress-chart-label flex items-center">
      <span className="w-2 h-2 rounded-full" style={{ backgroundColor: color }}></span>
      <span className="ms-2 text-xs">{title}</span>
    </div>
  );
};

export default ProgressChartLabel;
